import './polyfills';
import React, { Fragment, StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';

const root = createRoot(document.getElementById('root') as Element);
const StrictModeComponent =  process.env.NODE_ENV ? Fragment : StrictMode;

root.render(
  <StrictModeComponent>
    <App />
  </StrictModeComponent>
);
